import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  baseUrl = '';

  constructor(private http: HttpClient) {
    if (environment.production) {
      this.baseUrl = ''
    } else {
      this.baseUrl = 'http://localhost:5000'
    }
   }

  submitContactDetails(data){
    return this.http.post(`${this.baseUrl}/api/submitContactDetails`, data, { responseType: 'text' });
  }

  postContact(data) {
    return this.http.post(`${this.baseUrl}/api/postContact`, data, { responseType: 'json' });
  }

  private displayNameSource = new BehaviorSubject<any>('');
  displayName = this.displayNameSource.asObservable();

  updatedisplayName(data) {
    this.displayNameSource.next(data);
  };
}
